import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type PostDocumentAttachmentRequestType,
  type PostDocumentAttachmentResponseType,
  postDocumentAttachment,
} from '..';
import { queryKey } from './query-key';

export const usePostDocumentAttachment = () => {
  const queryClient = useQueryClient();

  const onSuccess = async (
    _data: PostDocumentAttachmentResponseType,
    variables: PostDocumentAttachmentRequestType,
  ) => {
    await queryClient.refetchQueries(queryKey.document(variables.documentId));
    await queryClient.refetchQueries(
      queryKey.documentsQueue(variables.documentId),
    );
    await queryClient.refetchQueries(
      queryKey.documentAttachments(variables.documentId),
    );
  };

  return useMutation({
    mutationFn: postDocumentAttachment,
    onSuccess,
  });
};
